var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface-Solid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-solid-multimedia-play-button-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24200",
    "data-name": "Path 24200",
    d: "M10.833,2.5a8.333,8.333,0,1,0,8.333,8.333A8.333,8.333,0,0,0,10.833,2.5Zm3.312,9.426h0l-3.764,2.628a1.334,1.334,0,0,1-2.1-1.094V8.206a1.334,1.334,0,0,1,2.1-1.094L14.145,9.74a1.333,1.333,0,0,1,0,2.187Z",
    transform: "translate(-0.833 -0.833)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24201",
    "data-name": "Path 24201",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm0,18.333A8.333,8.333,0,1,1,18.333,10,8.333,8.333,0,0,1,10,18.333Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24202",
    "data-name": "Path 24202",
    d: "M17.037,11.926,13.273,9.3a1.334,1.334,0,0,0-2.1,1.094v5.255a1.333,1.333,0,0,0,2.1,1.094l3.764-2.628h0a1.333,1.333,0,0,0,0-2.187Z",
    transform: "translate(-3.726 -3.02)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video-play.f79834bec40a474f9395d89c7e9bc141.svg";
export { ForwardRef as ReactComponent };